module.exports = __webpack_public_path__ + "static/img/会计引擎.d197059e.png";